<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import moment from "moment";
import Multiselect from 'vue-multiselect';
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
import 'vue-search-select/dist/VueSearchSelect.css'
import ErrorMessage from "../../components/error-message";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
    Multiselect,
      ModelSelect,
  },
  data() {
    return {
      errorMessage: "",
      disable:true,
      continuous_rule:false,
      title: "Markup Commission Entry",
      agents: [],
      admins: [],
      airlines: [],
      vendors: [],
      roles: [],
      item: {},
        visible:false,
        message:"",
      rolelist: [],
      exclude_class: [],
      options: [
        { name: 'A' },
        { name: 'B' },
        { name: 'C' },
        { name: 'D' },
        { name: 'E' },
        { name: 'F' },
        { name: 'G' },
        { name: 'H' },
        { name: 'I' },
        { name: 'J' },
      ],
      items: [
        {
          text: "Markup Commission",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: false,
      errors: null,
      form: {
        start_dateTime: "",
        end_dateTime:"",
        origin: "",
        destination: "",
        api_id: "",
        airline_code: "",
        user_role_id: "",
        user_id: "",
        agent_type: "",
        journey_type: "",
        markup_type: "",
        markup_value: "",
        commission_type: "",
        commission_value: "",
        apply_advanced_rules:"0",
        exclude_origin: "",
        exclude_airport: "",
        exclude_class: "",
        exclude_trip_type: "",
        exclude_fare_type: "",
        include_flight_type: "",
        extra_commission_type: "",
        economy_extra_commission: "",
        business_extra_commission: "",
        exclude_soto: "",
        exclude_oal_fare: "",
          is_domestic:"",
          is_lcc:"",
      },
      submitform: false,
      submitted: false,
    };
  },

  validations: {
    form: {
      start_dateTime: {
        required,
      },
      // end_dateTime: {
      //   required,
      // },
      // origin: {
      //   required,
      // },
      // destination: {
      //   required,
      // },
      // api_id: {
      //   required,
      // },
      // agent_type: {
      //   required,
      // },
      // journey_type: {
      //   required,
      // },
      // airline_code: {
      //   required,
      // },
      // user_role_id: {
      //   required,
      // },
      // user_id: {
      //   required,
      // },
      // markup_type: {
      //   required,
      // },
      // markup_value: {
      //   required,
      // },
      // commission_type: {
      //   required,
      // },
      // commission_value: {
      //   required,
      // },
      // exclude_origin: {
      //   required ,
      // },
      // exclude_airport: {
      //   required,
      // },
      // exclude_class: {
      //   required,
      // },
      // exclude_trip_type: {
      //   required,
      // },
      // exclude_fare_type: {
      //   required,
      // },
      // include_flight_type: {
      //   required,
      // },
      // extra_commission_type: {
      //   required,
      // },
      // economy_extra_commission: {
      //   required,
      // },
      // business_extra_commission: {
      //   required,
      // },
      // exclude_soto: {
      //   required,
      // },
      // exclude_oal_fare: {
      //   required,
      // },
    },
  },
    watch: {
        continuous_rule: function (value) {
            if(value){
                this.form.end_dateTime="";
            }
        }
    },
  mounted() {
    // this.getAgentList();
    this.getVendorList();
    this.getAirlineList();
    this.getAdminList();
    // this.getRoleList();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
      async getAdminList() {
          try {
              axios
                  .get("/api/user/approved/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          let nullArr=[];
                          nullArr.value=null;
                          nullArr.text='all';
                          arr.push(nullArr);
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                  if(temp[i].approved_agents[0].approval_status=='approved') {
                                      temp[i].value = temp[i].id;
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                      arr.push(temp[i]);
                                  }
                              }
                              if(temp[i].account_type=='b2c' && temp[i].first_name != null){
                                  temp[i].value = temp[i].id;
                                  temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                  arr.push(temp[i]);
                              }

                          }
                          this.admins = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    async getVendorList() {
      try {
        axios
          .get("/api/vendor/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.vendors = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getAirlineList() {
      try {
        axios
          .get("/api/airline/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
                var temp=response.data.data;
                var i;
                for (i=0;i<temp.length;i++){
                    temp[i].value=temp[i].code;
                    temp[i].text=temp[i].name+' ('+temp[i].code+')';
                }
              this.airlines = temp;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getAgentList() {
      try {
        axios
          .get("/api/agent/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.agents = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getRoleList() {
      try {
        axios
          .get("/api/role_list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.roles = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    formSubmit(event) {
      var classList = [];
      this.exclude_class.map(function(value, key) {
        classList.push(value.name);
      });
      if(this.form.api_id=='null'){
        this.form.api_id=null;
      }
       if(this.form.user_role_id=='null'){
        this.form.user_role_id=null;
      }
        if(this.form.user_id=='null'){
        this.form.user_id=null;
      }
       if(this.form.markup_type=='null'){
        this.form.markup_type=null;
      }
      if(this.form.commission_type=='null'){
        this.form.commission_type=null;
      }
      if(this.form.airline_code=='null'){
        this.form.airline_code=null;
      }
      if(this.form.agent_type=='null'){
        this.form.agent_type=null;
      }
      if(this.form.journey_type=='null'){
        this.form.journey_type=null;
      }
      if(this.form.end_dateTime!=""){
          this.form.end_dateTime=moment(new Date(this.form.end_dateTime)).format(
              "YYYY-MM-DD 23:59:59"
          )
      }
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/markup_com/create", {
          start_dateTime: moment(new Date(this.form.start_dateTime)).format(
            "YYYY-MM-DD 00:00:00"
          ),
          end_dateTime:this.form.end_dateTime,
          origin: this.form.origin,
          destination: this.form.destination,
          api_id: this.form.api_id,
          airline_code: this.form.airline_code,
          agent_type: this.form.agent_type,
          journey_type: this.form.journey_type,
          user_role_id: this.form.user_role_id,
          user_id: this.form.user_id,
          markup_type: this.form.markup_type,
          markup_value: this.form.markup_value,
          commission_type: this.form.commission_type,
          commission_value: this.form.commission_value,
          apply_advanced_rules: this.form.apply_advanced_rules,
          exclude_origin: this.form.exclude_origin,
          exclude_airport: this.form.exclude_airport,
          exclude_class: classList.join('|'),
          exclude_trip_type: this.form.exclude_trip_type,
          exclude_fare_type: this.form.exclude_fare_type,
          include_flight_type: this.form.include_flight_type,
          extra_commission_type: this.form.extra_commission_type,
          economy_extra_commission: this.form.economy_extra_commission,
          business_extra_commission: this.form.business_extra_commission,
          exclude_soto: this.form.exclude_soto,
          exclude_oal_fare: this.form.exclude_oal_fare,
            is_domestic: this.form.is_domestic,
            is_lcc: this.form.is_lcc,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.markupcom.reset();
            this.$swal("Good job!", "Markup Commission Created", "success");
            this.$router.push({ name: "markup_commission_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      event.target.reset();
    },
    getRoleListOnChange(event) {
      var _that = this;
      try {
        axios
          .get("/api/role/type", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
              type: event.target.value,
            },
          })
          .then((response) => {
            if (response.data.status) {
              _that.roles = response.data.data;
              _that.rolelist = [];
              response.data.data.map(function(value, key) {
                _that.rolelist[value.id] = value.type;
              });
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              _that.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    getUserOnChange(event) {
      var _that = this;
      try {
        axios
          .get("/api/user/type", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
              type: this.rolelist[event.target.value],
            },
          })
          .then((response) => {
            if (response.data.status) {
                let temp=response.data.data;
                let i;
                let arr=[];
                let nullArr=[];
                nullArr.value=null;
                nullArr.text='all';
                arr.push(nullArr);
                for (i=0;i<temp.length;i++){
                    if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                        if(temp[i].approved_agents[0].approval_status=='approved') {
                            temp[i].value = temp[i].id;
                            temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                            arr.push(temp[i]);
                        }
                    }
                    if(temp[i].account_type=='b2c' && temp[i].first_name != null){
                        temp[i].value = temp[i].id;
                        temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                        arr.push(temp[i]);
                    }

                }
                this.admins = arr;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              _that.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    applyAdvancedRules(event){
      if(event.target.checked==true){
        this.checked=true;
        this.disable=false;
        this.form.apply_advanced_rules="1";
      }
      else{
        this.disable=true;
        this.checked=false;
        this.form.apply_advanced_rules="0";
      }
    }
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="markupcom" @submit.prevent="formSubmit">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-time-five"></i> Rules Time Set</h4>
<!--                  <p class="badge badge-info">Continuous Rule</p>-->
<!--                  <input type="checkbox" v-model="continuous_rule" @change="applyContinuousRule($event)" />-->
                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group
                              id="lb_start_dateTime"
                              class="required"
                              label-cols-sm="12"
                              label-cols-lg="12"
                              label="Start Date"
                              label-for="start_dateTime"
                          >
<!--                              <b-form-input-->
<!--                              id="start_dateTime"-->
<!--                              v-model="form.start_dateTime"-->
<!--                              name="start_dateTime"-->
<!--                              class="form-control"-->
<!--                              placeholder="Type permission name"-->
<!--                              :class="{ 'is-invalid': submitted && $v.form.start_dateTime.$error }" type="datetime-local"></b-form-input>-->
                          <b-form-datepicker id="start_dateTime" v-model="form.start_dateTime" class="mb-2"></b-form-datepicker>
                              <div
                              v-if="submitted && $v.form.start_dateTime.$error"
                              class="invalid-feedback"
                              >
                              <span v-if="!$v.form.start_dateTime.required">This value is required.</span>
                              </div>
                          <div>
                              <b-form-checkbox
                                  id="checkbox-1"
                                  v-model="continuous_rule"
                                  name="checkbox-1"
                                  switch
                              >
                                  Apply Continuous Rule
                              </b-form-checkbox>
                          </div>
                          </b-form-group>

                    </div>
                    <div class="col-md-6">
                        <b-form-group
                              id="lb_end_dateTime"
                              label-cols-sm="12"
                              label-cols-lg="12"
                              label="End Date"
                              label-for="end_dateTime"
                          >
<!--                              <b-form-input-->
<!--                              id="end_dateTime"-->
<!--                              v-model="form.end_dateTime"-->
<!--                              :disabled="this.continuous_rule"-->
<!--                              name="end_dateTime"-->
<!--                              class="form-control"-->
<!--                              placeholder="Type permission name"-->
<!--                              type="datetime-local"></b-form-input>-->
                            <b-form-datepicker id="end_dateTime" v-model="form.end_dateTime" :disabled="this.continuous_rule" class="mb-2"></b-form-datepicker>
                             <!--  <div
                              v-if="submitted && $v.form.end_dateTime.$error"
                              class="invalid-feedback"
                              >
                              <span v-if="!$v.form.end_dateTime.required">This value is required.</span>
                              </div> -->
                          </b-form-group>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="origin">Origin</label>
                        <input
                          id="origin"
                          v-model="form.origin"
                          name="origin"
                          type="text"
                          class="form-control"
                          placeholder="Type origin name"
                        />
<!--                        <div-->
<!--                          v-if="submitted && $v.form.origin.$error"-->
<!--                          class="invalid-feedback"-->
<!--                        >-->
<!--                          <span v-if="!$v.form.origin.required">This value is required.</span>-->
<!--                        </div>-->
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="destination">Destination</label>
                        <input
                          id="destination"
                          v-model="form.destination"
                          name="destination"
                          type="text"
                          class="form-control"
                          placeholder="Type Destination "
                        />
<!--                        <div-->
<!--                          v-if="submitted && $v.form.destination.$error"-->
<!--                          class="invalid-feedback"-->
<!--                        >-->
<!--                          <span v-if="!$v.form.destination.required">This value is required.</span>-->
<!--                        </div>-->
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                          <label>Airline Code</label>
                          <model-select :options="airlines"
                                        v-model="form.airline_code"
                                        placeholder="Select Airline">
                          </model-select>
<!--                        <label for="airline_code">Airline Code</label>-->
<!--                        <select-->
<!--                          id="airline_code"-->
<!--                          name="airline_code"-->
<!--                          v-model="form.airline_code"-->
<!--                          class="form-control"-->
<!--                          placeholder="Select Airline Code"-->
<!--                          :class="{ 'is-invalid': submitted}">-->
<!--                          <option value="null">All</option>-->
<!--                          <option v-for="(airline, index) in airlines" :value="airline.code"-->
<!--                                v-bind:key="index">{{ airline.name }}-->
<!--                        </option>-->
<!--                        </select>-->
                      <!--   <div
                          v-if="submitted && $v.form.airline_code.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.form.airline_code.required">This value is required.</span>
                        </div> -->
                      </div>
                    </div>
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="is_domestic">Is Domestic</label>
                              <select
                                  id="is_domestic"
                                  name="is_domestic"
                                  v-model="form.is_domestic"
                                  class="form-control"
                              >
                                  <option value="" disabled style="display:none" selected>Select Is Domestic</option>
                                  <option value='1'>Yes</option>
                                  <option value='0'>No</option>
                              </select>
                              <!--                            <div-->
                              <!--                              v-if="submitted && $v.form.exclude_soto.$error"-->
                              <!--                              class="invalid-feedback"-->
                              <!--                            >-->
                              <!--                              <span v-if="!$v.form.exclude_soto.required">This value is required.</span>-->
                              <!--                            </div>-->
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="is_lcc">Is Lcc</label>
                              <select
                                  id="is_lcc"
                                  name="is_lcc"
                                  v-model="form.is_lcc"
                                  class="form-control"
                              >
                                  <option value="" disabled style="display:none" selected>Select Is Lcc</option>
                                  <option value='1'>Yes</option>
                                  <option value='0'>No</option>
                              </select>
                              <!--                            <div-->
                              <!--                              v-if="submitted && $v.form.exclude_soto.$error"-->
                              <!--                              class="invalid-feedback"-->
                              <!--                            >-->
                              <!--                              <span v-if="!$v.form.exclude_soto.required">This value is required.</span>-->
                              <!--                            </div>-->
                          </div>
                      </div>
                  </div>
                </div>
              </div>
              <div class="card">
                  <div class="card-body">
                      <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-user-plus"></i> Set API User</h4>
                      <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="api_id">API ID</label>
                              <select
                                id="api_id"
                                name="api_id"
                                v-model="form.api_id"
                                class="form-control"
                           >
                                  <option value="" disabled style="display:none" selected>Select Api Id</option>
                                <option value="null">All</option>
                                <option v-for="(vendor, index) in vendors" :value="vendor.id" v-if="vendor.is_active==1"
                                      v-bind:key="index">{{ vendor.api_provider }}
                              </option>
                              </select>
                           <!--    <div
                                v-if="submitted && $v.form.api_id.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.api_id.required">This value is required.</span>
                              </div> -->
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="journey_type">Journey Type</label>
                              <select
                                id="journey_type"
                                name="journey_type"
                                v-model="form.journey_type"
                                v-on:change="getRoleListOnChange"
                                class="form-control"
                               >
                                  <option value="" disabled style="display:none" selected>Select Journey Type</option>
                                <option value="null">All</option>
                                <option value="R">Return</option>
                                <option value="O">One Way</option>
                              </select>
                             <!--  <div
                                v-if="submitted && $v.form.journey_type.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.journey_type.required">This value is required.</span>
                              </div> -->
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="agent_type">User Type</label>
                              <select
                                id="agent_type"
                                name="agent_type"
                                v-model="form.agent_type"
                                v-on:change="getRoleListOnChange"
                                class="form-control"
                                >
                                  <option value="" disabled style="display:none" selected>Select User Type</option>
                                <option value="null">All</option>
                                <option value="b2b">B2B</option>
                                <option value="b2c">B2C</option>
                              </select>
                          <!--     <div
                                v-if="submitted && $v.form.agent_type.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.agent_type.required">This value is required.</span>
                              </div> -->
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="user_role_id">Select Role</label>
                              <select
                                id="user_role_id"
                                name="user_role_id"
                                v-model="form.user_role_id"
                                class="form-control"
                                v-on:change="getUserOnChange"
                               >
                                  <option value="" disabled style="display:none" selected>Select Role</option>
                                <option value="null">All</option>
                                <option v-for="(role, index) in roles" v-if="role.type!='admin'" v-bind:key="index" :value="role.id">{{ role.name}}
                              </option>
                              </select>
                             <!--  <div
                                v-if="submitted && $v.form.user_role_id.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.user_role_id.required">This value is required.</span>
                              </div> -->
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                                <label>Select User</label>
                                <model-select :options="admins"
                                              v-model="form.user_id"
                                              placeholder="Select User">
                                </model-select>
<!--                              <label for="user_id">Select User</label>-->
<!--                              <select-->
<!--                                id="user_id"-->
<!--                                name="user_id"-->
<!--                                v-model="form.user_id"-->
<!--                                class="form-control"-->
<!--                                placeholder="Type Select User"-->
<!--                                >-->
<!--                                  <option value="" disabled style="display:none" selected>Select User</option>-->
<!--                                <option value="null">All</option>-->
<!--                                <option v-for="(admin, index) in admins" v-if="admin.account_type != 'admin'" :value="admin.id"-->
<!--                                      v-bind:key="index">{{ admin.first_name+' '+admin.last_name }}-->
<!--                              </option>-->
<!--                              </select>-->
                           <!--    <div
                                v-if="submitted && $v.form.user_id.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.user_id.required">This value is required.</span>
                              </div> -->
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-body">
                      <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-shield"></i> Set Markup Commission</h4>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="markup_type">Markup Type</label>
                            <select
                              id="markup_type"
                              name="markup_type"
                              v-model="form.markup_type"
                              class="form-control"
                              placeholder="Type markup type"
                              >
                                <option value="" disabled style="display:none" selected>Select Markup Type</option>
                              <option value="flat">flat</option>
                              <option value="%">Percentage</option>
                            </select>
                           <!--  <div
                              v-if="submitted && $v.form.markup_type.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.markup_type.required">This value is required.</span>
                            </div> -->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="commission_type">Commission Type</label>
                            <select
                              id="commission_type"
                              name="commission_type"
                              v-model="form.commission_type"
                              class="form-control"
                              placeholder="Type Commission type"
                            >
                                <option value="" disabled style="display:none" selected>Select Commission Type</option>
                              <option value="flat">flat</option>
                              <option value="%">Percentage</option>
                            </select>
                        <!--     <div
                              v-if="submitted && $v.form.commission_type.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.commission_type.required">This value is required.</span>
                            </div> -->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="markup_value">Markup Value</label>
                            <input
                              id="markup_value"
                              v-model="form.markup_value"
                              name="markup_value"
                              type="number"
                              step="any"
                              class="form-control"
                              placeholder="Type Markup Value"
                            />
<!--                            <div-->
<!--                              v-if="submitted && $v.form.markup_value.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.markup_value.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="commission_value">Commission Value</label>
                            <input
                              id="commission_value"
                              v-model="form.commission_value"
                              name="commission_value"
                              type="number"
                              step="any"
                              class="form-control"
                              placeholder="Type Commission Value"
                            />
<!--                            <div-->
<!--                              v-if="submitted && $v.form.commission_value.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.commission_value.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                      </div>
                  </div>
              </div>
              <h2 class="badge badge-danger">Apply Advance Rule</h2> <input type="checkbox" v-model="checked" @change="applyAdvancedRules($event)" />
              <div class="card border border-danger">
                  <div class="card-body">
                      <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-hash"></i> Add Restriction Of Rule</h4>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="exclude_origin">Exclude Origin</label>
                            <input
                              id="exclude_origin"
                              :disabled="this.disable"
                              v-model="form.exclude_origin"
                              name="exclude_origin"
                              type="text"
                              class="form-control"
                              placeholder="Type Exclude Origin"

                            />
<!--                            <div-->
<!--                              v-if="submitted && $v.form.exclude_origin.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.exclude_origin.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="exclude_airport">Exclude Airport</label>
                            <input
                              id="exclude_airport"
                              :disabled="this.disable"
                              v-model="form.exclude_airport"
                              name="exclude_airport"
                              type="text"
                              class="form-control"
                              placeholder="Type Exclude Airport"

                            />
<!--                            <div-->
<!--                              v-if="submitted && $v.form.exclude_airport.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.exclude_airport.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <label class="typo__label">Exclude Class</label>
                          <multiselect v-model="exclude_class" :disabled="this.disable" :options="options" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="false">
                            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                          </multiselect>
                        </div>
                        <!-- <div class="col-md-6">
                          <div class="form-group">
                            <label for="exclude_class">Exclude Class</label>
                            <input
                              id="exclude_class"
                              v-model="form.exclude_class"
                              name="exclude_class"
                              type="text"
                              class="form-control"
                              placeholder="Type Exclude Class"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.exclude_class.$error }"
                            />
                            <div
                              v-if="submitted && $v.form.exclude_class.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.exclude_class.required">This value is required.</span>
                            </div>
                          </div>
                        </div> -->
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="exclude_trip_type">Exclude Trip Type</label>
                            <select
                                id="exclude_trip_type"
                                :disabled="this.disable"
                                name="exclude_trip_type"
                                v-model="form.exclude_trip_type"
                                class="form-control"
                                placeholder="Type trip type"
                                >
                                <option value="" disabled style="display:none" selected>Select Exclude Trip Type</option>
                                <option value="null">All</option>
                                <option value="R">Return</option>
                                <option value="O">One Way</option>
                                <option value="M">Multi City</option>
                              </select>
<!--                            <div-->
<!--                              v-if="submitted && $v.form.exclude_trip_type.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.exclude_trip_type.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="exclude_fare_type">Exclude Fare Type</label>
                            <select
                                id="exclude_fare_type"
                                :disabled="this.disable"
                                name="exclude_fare_type"
                                v-model="form.exclude_fare_type"
                                class="form-control"
                                placeholder="Type trip type"
                               >
                                <option value="" disabled style="display:none" selected>Select Exclude Fare Type</option>
                               <option value="null">All</option>
                                <option value="flat">Flat</option>
                                <option value="parcentage">parcentage</option>
                              </select>
<!--                            <div-->
<!--                              v-if="submitted && $v.form.exclude_fare_type.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.exclude_fare_type.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="include_flight_type">Include Flight Type</label>
                            <select
                                id="include_flight_type"
                                :disabled="this.disable"
                                name="include_flight_type"
                                v-model="form.include_flight_type"
                                class="form-control"
                                placeholder="Type trip type"
                               >
                                <option value="" disabled style="display:none" selected>Select Include Flight Type</option>
                               <option value="null">All</option>
                                <option value="public">Public</option>
                                <option value="private">Private</option>
                              </select>
<!--                            <div-->
<!--                              v-if="submitted && $v.form.include_flight_type.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.include_flight_type.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="extra_commission_type">Extra Commission Type</label>
<!--                            <input-->
<!--                              id="extra_commission_type"-->
<!--                              :disabled="this.disable"-->
<!--                              v-model="form.extra_commission_type"-->
<!--                              name="extra_commission_type"-->
<!--                              type="text"-->
<!--                              class="form-control"-->
<!--                              placeholder="Type Extra Commission Type"-->

<!--                            />-->
                              <select
                                  id="extra_commission_type"
                                  name="markup_type"
                                  :disabled="this.disable"
                                  v-model="form.extra_commission_type"
                                  class="form-control"
                                  placeholder="Select Extra Commission Type"
                              >
                                  <option value="" disabled style="display:none" selected>Select Extra Commission Type</option>
                                  <option value="flat">flat</option>
                                  <option value="%">Percentage</option>
                              </select>
<!--                            <div-->
<!--                              v-if="submitted && $v.form.extra_commission_type.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.extra_commission_type.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="economy_extra_commission">Economy Extra Commission</label>
                            <input
                              id="economy_extra_commission"
                              :disabled="this.disable"
                              v-model="form.economy_extra_commission"
                              name="economy_extra_commission"
                              type="text"
                              class="form-control"
                              placeholder="Type Economy Extra Commission"

                            />
<!--                            <div-->
<!--                              v-if="submitted && $v.form.economy_extra_commission.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.economy_extra_commission.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="business_extra_commission">Business Extra Commission</label>
                            <input
                              id="business_extra_commission"
                              :disabled="this.disable"
                              v-model="form.business_extra_commission"
                              name="business_extra_commission"
                              type="text"
                              class="form-control"
                              placeholder="Type Business Extra Commission"

                            />
<!--                            <div-->
<!--                              v-if="submitted && $v.form.business_extra_commission.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.business_extra_commission.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="exclude_soto">Exclude SOTO</label>
                            <select
                              id="exclude_soto"
                              :disabled="this.disable"
                              name="exclude_soto"
                              v-model="form.exclude_soto"
                              class="form-control"
                              >
                                <option value="" disabled style="display:none" selected>Select Exclude SOTO</option>
                              <option value='1'>Yes</option>
                              <option value='0'>No</option>
                            </select>
<!--                            <div-->
<!--                              v-if="submitted && $v.form.exclude_soto.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.exclude_soto.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="exclude_oal_fare">Exclude OAL Fare</label>
                            <select
                              id="exclude_oal_fare"
                              :disabled="this.disable"
                              name="exclude_oal_fare"
                              v-model="form.exclude_oal_fare"
                              class="form-control"
                              >
                                <option value="" disabled style="display:none" selected>Select Exclude OAL Fare</option>
                              <option value='1'>Yes</option>
                              <option value='0'>No</option>
                            </select>
<!--                            <div-->
<!--                              v-if="submitted && $v.form.exclude_oal_fare.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.exclude_oal_fare.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                      </div>
                  </div>
              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
.dropdown-menu.show {
    display: block;
    z-index: 10003;
}
.multiselect__placeholder{
    color: #393b3e !important;
}
.form-control{
    color: #76797b !important;
}
</style>
